import { createReducer, on } from '@ngrx/store';
import { createTypes, CreateTypes } from '../utilities/Constants';
import { SharedActions } from '../actions';

export const createTypeKey = 'createTypeInContext';

export const initialCreateTypeInContextState: CreateTypes = createTypes.transaction;

export const createTypeReducer = createReducer(
    initialCreateTypeInContextState,
    on(SharedActions.standingAuthComponentLoaded, () => {
        return createTypes.standingAuthorization;
    }),
    on(SharedActions.createRequestComponentLoaded, () => {
        return createTypes.transaction;
    }),
    on(SharedActions.initiateAndReleaseComponentLoaded, () => {
        return createTypes.initrelease;
    })
);
